export var ListBulkAction;
(function (ListBulkAction) {
    ListBulkAction["Append"] = "append";
    ListBulkAction["Remove"] = "remove";
    ListBulkAction["Sync"] = "sync";
})(ListBulkAction || (ListBulkAction = {}));
export var ListSearchAction;
(function (ListSearchAction) {
    ListSearchAction["IndividualProductPack"] = "individualProductPack";
    ListSearchAction["MedicinalProduct"] = "medicinalProduct";
    ListSearchAction["PoisonSchedule"] = "poisonSchedule";
    ListSearchAction["AtcCode"] = "atcCode";
})(ListSearchAction || (ListSearchAction = {}));
